import { useEffect, useState, useRef } from 'react';
import {
    FormGroup,
    FormControlLabel,
    Checkbox,
    Typography,
    Autocomplete,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../../lib/axios';
import checkAndLock from '../../../../GlobalFunction/checkAndLock';
import UnLock from '../../../../GlobalFunction/UnLock';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import CustomAutocomplete from '../../../AutoComplete/AutoComplete';
import { useSelector } from 'react-redux';
import { selectGlobalProperty } from '../../../../redux/propertySlice';

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'HkWrkAreaName', label: 'Work Area', minWidth: 70 },
    { id: 'Abrv', label: 'Abbrivation', minWidth: 70 },
    { id: 'Remark', label: 'Remark', minWidth: 70 },
];

const WorkArea = () => {
    const [formData, setFormData] = useState({
        HkWrkAreaName: '',
        HkWrkStnId: '',
        Abrv: '',
        Remark: '',
    });

    const [error, setError] = useState({
        HkWrkAreaName: false,
        HkWrkStnId: '',
        Abrv: false,
    });

    const navigate = useNavigate();
    const location = useLocation();
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [currentWorkArea, setCurrentWorkArea] = useState(null);
    const [workstation, setWorkStation] = useState([]);
    const [mode, setMode] = useState('view');
    const [status, setStatus] = useState("1");
    const [lastInsertedHkWrkAreaId, setLastInsertedHkWrkAreaId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [userId] = useState(sessionStorage.getItem('UserId'));
    const [dataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const hkWrkAreaNameRef = useRef(null);
    const abrvRef = useRef(null);
    const remarkRef = useRef(null);
    const globalProperty = useSelector(selectGlobalProperty);

    useEffect(() => {
        if (location.state && location.state.HkWrkAreaId) {
            setCurrentWorkArea(location.state.HkWrkAreaId);
            fetchWorkAreaData(location.state.HkWrkAreaId, "R");
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location]);

    const fetchWorkAreaData = async (id, flag) => {
        try {
            const response = await axiosInstance.post(`MstHkWrkArea/RetriveMstHkWrkArea`, {
                HkWrkAreaId: parseInt(id),
                Flag: flag,
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const workData = response.data.Data[0];

                if (flag === "D") {
                    toast.success('Work area deleted successfully.');
                    return;
                }
                setFormData({
                    HkWrkStnId: workData.HkWrkStnId,
                    HkWrkAreaName: workData.HkWrkAreaName || '',
                    Abrv: workData.Abrv || '',
                    Remark: workData.Remark || '',
                });
                setStatus(workData.status?.toString() || "1");
                setIsFormDisabled(true);
                setCurrentWorkArea(workData.HkWrkAreaId);
            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
            } else {
                toast.info(response.data.Message || 'No record Found.');
            }
        } catch (error) {
            toast.error('Error while fetching work area.');
        }
    };

    useEffect(() => {
        getRow();
        fetchWorkStation();
    }, [globalProperty]);

    const getRow = async () => {
        try {
            const res = await axiosInstance.post('MstHkWrkArea/getMstHkWrkAreaDashBoard', {
                start: 0,
                PageSize: 1,
                SearchText: "",
            });
            if (res.data && res.data.Data) {
                setRows(res.data.Data);
                setDataForPrint(res.data.Data);
            }
        } catch (err) {
            toast.error('Error fetching data:', err);
        }
    };

    const fetchWorkStation = async () => {
        try {
            const response = await axiosInstance.post('MstHkWrkStn/getMstHkWrkStndrp', {
                PropId: globalProperty
            });
            if (response.data.Status === 0) {
                const data = response.data.Data || [];
                setWorkStation(data);

                if (mode === 'add' && data.length > 0 && !formData.HkWrkStnId) {
                    setFormData((prev) => ({
                        ...prev,
                        HkWrkStnId: data[0].Id,
                    }));
                }
            };
        } catch (error) {
            toast.error("Error while fetching work station.");
        }
    };

    const handlePrevious = async () => {
        if (currentWorkArea && currentWorkArea > 1) {
            await fetchWorkAreaData(currentWorkArea, "P");
        }
    };

    const handleNext = async () => {
        if (currentWorkArea) {
            await fetchWorkAreaData(currentWorkArea, "N");
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === hkWrkAreaNameRef.current) {
                abrvRef.current.focus();
            } else if (event.target === abrvRef.current) {
                remarkRef.current.focus();
            }
        }
    };

    const handleSubmit = async () => {
        let hasError = false;

        if (!formData.HkWrkAreaName) {
            toast.error('Work Area is required.');
            setError((prev) => ({ ...prev, HkWrkAreaName: true }));
            hasError = true;
        } else {
            setError((prev) => ({ ...prev, HkWrkAreaName: false }));
        }

        if (hasError) return;

        try {
            const payload = {
                HkWrkStnId: formData.HkWrkStnId || 1,
                HkWrkAreaName: formData.HkWrkAreaName,
                Abrv: formData.Abrv,
                Remark: formData.Remark,
                status: status,
            };

            let response;
            if (mode === 'edit') {
                payload.HkWrkAreaId = currentWorkArea;
                payload.UpdatedBy = parseInt(userId, 7);
                response = await axiosInstance.patch(`MstHkWrkArea/UpdateMstHkWrkArea`, payload);
            } else {
                payload.CreatedBy = parseInt(userId, 7);
                response = await axiosInstance.post(`MstHkWrkArea/InsertMstHkWrkArea`, payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedHkWrkAreaId(response.data.Data);
                    await fetchWorkAreaData(response.data.Data, "R");
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentWorkArea(response.data.Data);
                } else {
                    setMode('view');
                    setIsFormDisabled(true);
                    await UnLock(currentWorkArea, "MstHkWrkArea", "HkWrkAreaId");
                }
            } else {
                toast.info(response.data.Message || 'No record found.');
            }
        } catch (error) {
            toast.error('Error while saving work area.');
        }
    };

    const handleEdit = async () => {
        let flag = await checkAndLock(currentWorkArea, "MstHkWrkArea", "HkWrkAreaId");
        switch (flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record Already Locked.", { autoClose: 500 });
                break;
            case 2:
                toast.error("Record Failed To Lock.", { autoClose: 500 });
                break;
            default:
                toast.error("Something Went Wrong.", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            HkWrkAreaName: '',
            Abrv: '',
            Remark: '',
        });
        setCurrentWorkArea(null);
        setStatus("1");

        setTimeout(() => {
            hkWrkAreaNameRef.current?.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            await fetchWorkAreaData(1, "L");
            await UnLock(currentWorkArea, "MstHkWrkArea", "HkWrkAreaId");
            setStatus("1");
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    const handleExit = () => {
        navigate('/workareatable');
    };

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        const flag = await checkAndLock(currentWorkArea, "MstHkWrkArea", "HkWrkAreaId");
        switch (flag) {
            case 0:
                setOpenConfirmDialog(false);
                await fetchWorkAreaData(currentWorkArea, "D");
                await fetchWorkAreaData(1, "N");
                setStatus("1");
                setMode('view');
                setIsFormDisabled(true);
                break;
            case 1:
                toast.info("Record Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.error("Record Failed To Lock", { autoClose: 500 });
                break;
            default:
                toast.error("Something Went Wrong", { autoClose: 500 });
        }
    };

    return (
        <>
            <Box className="form-container"
                sx={{
                    width: { xs: "calc(100vw - 52px)", sm: "auto", md: "auto" },
                    maxWidth: { xs: "calc(100vw - 52px)", sm: "auto", md: "auto" },
                    height: { xs: "91.5vh", sm: "93.5vh", md: "auto", lg: "92vh" },
                    overflowX: "hidden",
                    overflowY: { xs: "auto", sm: "hidden", md: "hidden", lg: "hidden" },
                }}
            >
                <ToastContainer />
                <Grid container spacing={1} className="form_grid">
                    <Grid
                        item
                        xs={12}
                        className="form_title"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' },
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '7px', sm: 0 },
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-previous"
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '7px' }, display: 'block' }}
                                disabled={mode !== 'view' || !currentWorkArea || currentWorkArea === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-next"
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: 'block' }}
                                disabled={mode !== 'view' || !currentWorkArea}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' },
                            }}
                        >
                            Work Area/Sub Station
                        </Typography>

                        <Grid sx={{ display: 'flex', justifyContent: 'end' }}>
                            <CrudButtons
                                moduleName="Work Area/Sub Station"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={1} justifyContent='center'>
                            {/* <Grid item xs={12} md={4} lg={4}>
                                <CustomAutocomplete
                                    options={workstation}
                                    id="work-autocomplete"
                                    name="HkWrkStnId"
                                    label={<span> Work Station <span style={{ color: 'red' }}>*</span></span>}
                                    value={workstation.find((prop) => prop.Id == formData.HkWrkStnId) || null}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    size="small"
                                    getOptionLabel={(option) => option.Name || ''}
                                    error={error.HkWrkStnId}
                                    helperText={error.HkWrkStnId && ""}
                                    className="custom-textfield"
                                    variant='filled'
                                />
                            </Grid> */}

                            <Grid item xs={12} md={4} lg={6}>
                                <TextField
                                    id="HkWrkAreaName"
                                    name="HkWrkAreaName"
                                    label={
                                        <span>
                                            Work Area <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.HkWrkAreaName}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    error={error.HkWrkAreaName}
                                    helperText={error.HkWrkAreaName && ""}
                                    inputRef={hkWrkAreaNameRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={8} lg={6}>
                                <TextField
                                    id="Abrv"
                                    name="Abrv"
                                    label="Abbrivation/Code"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Abrv}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={abrvRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={2} justifyContent='center'>
                            <Grid item xs={12} md={5} lg={10}>
                                <TextField
                                    id="Remark"
                                    name="Remark"
                                    label="Remark"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} lg={2}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isFormDisabled}
                                                checked={status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label="Status"
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }}
                                    onClick={handleAdd}
                                    disabled
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }}
                                    onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant="contained" sx={{
                                    mr: 1,
                                    background: "linear-gradient(290deg,   #b9d0e9, #e9f2fa)",
                                }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{
                                    mr: 1,
                                    background: "linear-gradient(290deg,   #b9d0e9, #e9f2fa)",
                                }} onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(dataForPrint).length > 0 && (
                    <ReportTable
                        columns={columns}
                        rows={rows}
                        title="Work Area"
                        contentRef={contentRef}
                        customStyles={{ backgroundColor: '#f5f5f5' }}
                    />
                )}
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': { backgroundColor: '#1565c0', color: 'white' },
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': { backgroundColor: '#1565c0', color: 'white' },
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default WorkArea;
